import React from "react";
import Search from "./Search";

export default function Five(props) {
  return (
    <div>
      <div class="row" id="showForecast">     
      </div>
      <Search />
    </div>
  );
}
